import { useState } from 'react';

import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { equipmentApi } from '@entities/equipment';

import { getEquipmentPositionText } from '../lib/getEquipmentPositionText';

interface UseEquipmentHeaderParams {
    onFilterChange: (value: string) => void;
}

export const useEquipmentHeader = ({ onFilterChange }: UseEquipmentHeaderParams) => {
    const { t } = useTranslation();
    const { data: totalInfo } = useQuery(equipmentApi.getTotalInfoQueryOptions());
    const [isSearchMode, setIsSearchMode] = useState(false);

    const closeSearchMode = () => {
        onFilterChange('');
        setIsSearchMode(false);
    };

    const getPositionText = (count: number) =>
        getEquipmentPositionText(count, {
            one: t('BoardHeader.return.position'),
            few: t('BoardHeader.return.position_genitive'),
            many: t('BoardHeader.return.positions'),
        });

    return {
        t,
        totalInfo,
        isSearchMode,
        exportEquipmentUrl: equipmentApi.exportEquipmentUrl(),
        openSearchMode: () => setIsSearchMode(true),
        closeSearchMode,
        getPositionText,
    };
};
